// extracted by mini-css-extract-plugin
module.exports = {"weapons":"Weapons_weapons__1jtas","playAgainBtn":"Weapons_playAgainBtn__3JWaV","newGameLink":"Weapons_newGameLink__e96p5"};